import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

function List(props) {

    const [users, setUsers] = useState([
        // {id: 1, username: "jack", email: "jack@qq.com"},
        // {id: 2, username: "mary", email: "mary@qq.com"},
    ])

    useEffect(() => {

        //ajax
        setTimeout(() => {
            setUsers([
                {id: 1, username: "jack", email: "jack@qq.com"},
                {id: 2, username: "mary", email: "mary@qq.com"},
            ])
        }, 1000)

    }, [])

    return (
        <div>

            <div>
                <Link to={"/member/create"}>新增</Link>
            </div>

            <table border="1">
                <thead>
                <tr>
                    <td>姓名</td>
                    <td>邮箱</td>
                    <td>操作</td>
                </tr>
                </thead>
                <tbody>

                {users.map((user) => {
                    return (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.username}</td>
                            <td>{user.email}</td>
                            <td>
                                <Link to={"/member/edit/" + user.id}>编辑</Link>
                            </td>
                        </tr>
                    )
                })}

                </tbody>
            </table>

        </div>
    )
}

export default List;